module.exports = __webpack_public_path__ + "img/hzzw.b11514d5.jpg";